'use strict';
module.exports = require('./InputMask.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/inputmask/index.js
// module id = 8
// module chunks = 1